import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

export type CircledIconVariant =
  | 'icon-default'
  | 'icon-emphasized'
  | 'icon-white'
  | 'icon-blue'
  | 'icon-danger'
  | 'icon-success';

export type TooltipPos = 'left' | 'right' | 'top' | 'bottom';

export type customCircledIconProps = React.PropsWithChildren<{
  variant?: CircledIconVariant;
  icon?: IconProp;
  size?: '' | 'icon-sm' | 'icon-lg';
  iconClassName?: string;
  label?: string;
  tooltipText?: string | React.ReactNode;
  tooltipPos?: TooltipPos;
}>;

const iconName = (iconName: IconProp) => <FontAwesomeIcon icon={iconName} />;

const CircledIcon = ({
  variant = 'icon-default',
  icon,
  size = '',
  iconClassName = '',
  label,
  tooltipText,
  tooltipPos = 'top',
  ...props
}: customCircledIconProps) => {
  let iconElement;
  if (tooltipText) {
    iconElement = (
      <OverlayTrigger
        placement={tooltipPos}
        overlay={<Tooltip id={`tooltip-${tooltipPos}`}>{tooltipText}</Tooltip>}
      >
        <span
          className={`circled-icon ${variant} ${size} ${iconClassName}`}
          {...props}
        >
          {icon && iconName(icon)}
        </span>
      </OverlayTrigger>
    );
  } else {
    iconElement = (
      <span
        className={`circled-icon ${variant} ${size} ${iconClassName}`}
        {...props}
      >
        {icon && iconName(icon)}
      </span>
    );
  }

  if (!label) {
    return iconElement;
  } else {
    return (
      <span className="d-flex align-items-center">
        {iconElement}
        <span className="icon-label">{label}</span>
      </span>
    );
  }
};

export default CircledIcon;
